import { render, staticRenderFns } from "./StateFlag.vue?vue&type=template&id=5b49819d&"
import script from "./StateFlag.vue?vue&type=script&lang=js&"
export * from "./StateFlag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports